import { createRouter } from 'vue-router'
import history          from './history'
import routes           from './routes'

export default createRouter({
  history,
  routes,
})
